import validate from "/builds/robustastudio/midea/miraco-website/node_modules/.pnpm/nuxt@3.17.5_@parcel+watcher@2.5.1_@types+node@24.0.3_db0@0.3.2_eslint@9.29.0_jiti@2.4.2_566dc9b4357b2f0bceb3c93f153e4e5b/node_modules/nuxt/dist/pages/runtime/validate.js";
import redirect_45global from "/builds/robustastudio/midea/miraco-website/middleware/redirect.global.ts";
import manifest_45route_45rule from "/builds/robustastudio/midea/miraco-website/node_modules/.pnpm/nuxt@3.17.5_@parcel+watcher@2.5.1_@types+node@24.0.3_db0@0.3.2_eslint@9.29.0_jiti@2.4.2_566dc9b4357b2f0bceb3c93f153e4e5b/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  redirect_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  auth: () => import("/builds/robustastudio/midea/miraco-website/middleware/auth.ts")
}